import React from 'react';

import SliderComponent from '../../Slider';
import { Splitview, Split } from '../../Split';
import { SLIDER_TICKS } from '../../../constants';
import { StatementCounter, Statement } from '../../Slider/styles';

type SliderProps = {
  title: String,
  id: Number,
  questions: Array,
  answer: Object,
  setAnswer: Function,
  tip: String,
  setTip: Function,
};

const Slider = ({
  title, id, questions, setAnswer, answer = {}, setTip, tip,
}: SliderProps) => (
  <Splitview>
    <Split width={30} left border>
      {id && (
        <StatementCounter color="partgreen">
          Stelling
          {' '}
          {id}
          /8
        </StatementCounter>
      )}
      <Statement>{title}</Statement>
    </Split>
    <Split width={70}>
      {questions.map((question, index) => (
        <div key={question}>
          <h3>{question}</h3>
          <SliderComponent
            value={answer[index]}
            onValueChange={(value) => {
              const newAnswer = {
                ...answer,
                [index]: value,
              };

              setAnswer(newAnswer);
              setTip(Math.abs(+newAnswer[0] - +newAnswer[1]) > 1 ? tip : null);
            }}
            ticks={SLIDER_TICKS}
          />
        </div>
      ))}
    </Split>
  </Splitview>
);

export default Slider;
